const Google = {
  enable() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", "AW-793298531");
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-793298531";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  init() {},
  _enviarSnippet(label) {
    window.gtag("event", "conversion", {
      send_to: `AW-793298531/${label}`
    });
  },
  paso1() {
    Google._enviarSnippet("U8U_CIO0qpAZEOOMo_oC");
  },
  gracias() {
    Google._enviarSnippet("q0N3CO7to5AZEOOMo_oC");
  },
  mensaje(context) {
    const mje = Number(context.mutation.payload.params.mje);

    if (mje === 0) {
      // ya registrado
      Google._enviarSnippet("pKEDCL_ZnpAZEOOMo_oC");
    }
    if (mje === 1) {
      // no hay cupo
      Google._enviarSnippet("lfDsCPb4o5AZEOOMo_oC");
    }
  }
};

export default Google;
